module.exports = __webpack_public_path__ + "img/9788958201090.1a7f757b.jpg";